// formatNumber(1234);  ==>  "1.2K"
const formatCompactNumber = (num) => {
  if(!num) return 0;

  return num >= 1000
    ? (num / 1000).toFixed(1).replace(/\.0$/, "") + "k"
    : num.toString();
};

export default formatCompactNumber;
